import React, { Component } from "react";
import "./App.css";
import Header from "./Components/Header";
import About from "./Components/About";
import Servicii from "./Components/Servicii";
import Portfolio from "./Components/Portfolio";
import Testimonials from "./Components/Testimonials";
import Proiect from "./Components/Proiect";
import ProiectPage from "./Components/ProiectPage";
import Footer from "./Components/Footer";

// Fara React.lazy/Suspense: HTML-ul pre-randat de react-snap nu are marcajele de Suspense
// pe care le asteapta hydrateRoot, iar hidratarea esua (erorile React #418/#423).

// Rutare minima, fara react-router: o singura pagina in plus (vezi reactSnap.include).
const isPaginaProiect = () => window.location.pathname.replace(/\/+$/, "") === "/proiect-regio";

class App extends Component {
  constructor(props) {
    super(props);
    // La pre-randare react-snap salveaza datele in window.__SITE_DATA__ (vezi snapSaveState),
    // ca prima randare din browser sa fie identica cu HTML-ul pre-randat.
    this.state = { resumeData: window.__SITE_DATA__ || {} };
  }

  componentDidMount() {
    window.snapSaveState = () => ({ __SITE_DATA__: this.state.resumeData });

    fetch("/dateSite.json", { cache: "no-cache" })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => this.setState({ resumeData: data }))
      .catch(err => console.error("Failed to load site data:", err));
  }

  render() {
    if (isPaginaProiect()) {
      return (
        <div className="App">
          <ProiectPage data={this.state.resumeData.main} />
        </div>
      );
    }

    return (
      <div className="App">
        <Header data={this.state.resumeData.main} />
        <About data={this.state.resumeData.main} />
        <Servicii data={this.state.resumeData.servicii} />
        <Portfolio data={this.state.resumeData.portfolio} />
        <Testimonials data={this.state.resumeData.testimonials} />
        <Proiect />
        <Footer data={this.state.resumeData.main} />
      </div>
    );
  }
}

export default App;
